import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, CircleDashed } from 'lucide-react';

export function MappingBadge({ mapping }) {
  if (!mapping || mapping.status !== 'resolved') {
    return <Badge variant="secondary" className="bg-amber-100 text-amber-800" data-testid="mapping-badge-decision-needed"><CircleDashed className="h-3 w-3 mr-1" />Decision needed</Badge>;
  }
  if (mapping.needs_check_in_qbo) {
    return (
      <Badge variant="secondary" className="bg-sky-100 text-sky-800" data-testid="mapping-badge-not-verified" title="Mapped locally but not yet verified active in QBO — blocks this draft.">
        {mapping.resolved_reference_name} — Not verified in QBO
      </Badge>
    );
  }
  return <Badge className="bg-emerald-600" data-testid="mapping-badge-resolved"><CheckCircle2 className="h-3 w-3 mr-1" />{mapping.resolved_reference_name}</Badge>;
}
